import React from "react";
import { observer } from "mobx-react";
import TopCategoriesCard from "./TopCategoriesCard";
import { MenuCategoryRevenueStats } from "../../../../../../services/stats/models";
import { Space } from "../../../../../../common/components/libs";


const TopCategoriesCards = ({ result }: { result: MenuCategoryRevenueStats[] }) => {

    return (

        <>
            {
                result.map(item => {
                    return <>
                        <TopCategoriesCard item={item}/>
                        <Space size={10}/>
                    </>;
                })
            }
        </>

    );
};

export default observer(TopCategoriesCards);
